export const environment = {
    production: true,
    api: 'https://api.notariuszosielsko.pl/api',
};
